import React from "react";
import Button from "src/components/Button";
import Checkbox from "src/components/Checkbox";
import DataTable from "src/components/Table";
import { StyledTableCell } from "src/components/Table/TableCell";
import TableRow from "src/components/Table/TableRow";
import { colors } from "src/styles";
import { ID, WashroomsFormInput, WashroomsListForTable } from "src/types";
import styled from "styled-components";

export interface WashroomsTableProps {
  isLoading: boolean;
  headers: string[];
  data: WashroomsListForTable[];
  onRowClick: (id: ID, label: string) => void;
  washroomSelectActive?: boolean;
  selectedWashrooms?: Set<ID>;
  onWashroomSelect?: (washroomId: ID, isChecked: boolean) => void;
  onWashroomEdit?: (washroom: WashroomsFormInput) => void;
  isClient?: boolean;
}

export const WashroomsTable = ({
  isLoading,
  headers,
  data,
  onRowClick,
  washroomSelectActive,
  selectedWashrooms = new Set(),
  onWashroomSelect,
  onWashroomEdit,
  isClient,
}: WashroomsTableProps) => {
  const handleIndividualSelect = (washroomId: ID, isChecked: boolean) => {
    if (onWashroomSelect) {
      onWashroomSelect(washroomId, isChecked);
    }
  };

  const handleIndividualEdit = (e: React.MouseEvent, washroomId: ID, label: string) => {
    e.stopPropagation();
    if (onWashroomEdit) {
      onWashroomEdit({ id: washroomId, label });
    }
  };

  return (
    <DataTable isLoading={isLoading} headers={headers}>
      <>
        {data?.map(({ id, label }: WashroomsListForTable) => {
          const isSelected = selectedWashrooms.has(id);
          return (
            <TableRow
              onClick={() => !washroomSelectActive && onRowClick(id, label)}
              $clickable={!washroomSelectActive}
              key={id}
            >
              {washroomSelectActive && (
                <StyledCell>
                  <Checkbox
                    checked={isSelected}
                    onChange={(e) => handleIndividualSelect(id, e.target.checked)}
                    label=""
                    containerStyle={"justify-content: flex-start;"}
                    checkboxStyle={"width: 20px; height: 20px;"}
                  />
                </StyledCell>
              )}
              <StyledCell>{id}</StyledCell>
              <StyledCell>{label}</StyledCell>
              {!isClient && (
                <StyledCell>
                  <Button text="Edit" onClick={(e) => handleIndividualEdit(e, id, label)} />
                </StyledCell>
              )}
            </TableRow>
          );
        })}
      </>
    </DataTable>
  );
};

interface StyledCellProps {
  $endTime?: string;
}

const StyledCell = styled(StyledTableCell)<StyledCellProps>`
  height: 50px;
  box-sizing: content-box;
  padding: 10px;
  color: ${({ $endTime }: StyledCellProps) => ($endTime === "" ? colors.green.light : "")};
`;
